import { css } from 'lit';
export default css `
  .container {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .video {
    width: 100%;
    height: 100%;
    border-radius: var(--amityeko-radius-large);
    object-fit: cover;
    z-index: 0;
  }

  .video__animation {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .video__title {
    position: absolute;
  }

  .controls {
    z-index: 2;
  }

  .control {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .button {
    border: 0;
    box-sizing: border-box;
    background: transparent;
    width: 0;
    border-color: transparent transparent transparent var(--amityeko-color-font-light);
    transition: 100ms all ease;
    cursor: pointer;
    /** play state */
    border-style: solid;
    border-width: 10px 0px 10px 15px;
  }

  .button:hover {
    border-color: transparent transparent transparent var(--amityeko-color-font-light);
  }

  .button--pause {
    height: 15px;
    border-style: double;
    border-width: 0 0 0 15px;
  }

  .speaker {
    position: absolute;
    top: 12px;
    left: 12px;
  }

  .controls__bottom {
    position: absolute;
    left: 12px;
    bottom: 12px;
    right: 12px;
    padding: 20px;
    border-radius: var(--amityeko-radius-medium);
    background: rgba(37, 37, 37, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    opacity: 0;
  }

  .container:hover .controls__bottom {
    opacity: 1;
  }

  .timeline {
    width: 100%;
    height: 2px;
  }

  .bar {
    background: rgba(120, 120, 128, 0.32);
    border-radius: var(--amityeko-radius-medium);
    height: 5px;
    flex: 1;
    display: flex;
  }

  .inner {
    background: #ccc;
    width: 0%;
    height: 100%;
  }

  .progress__circle {
    width: 15px;
    height: 15px;
    background-color: #ffffff;
    border-radius: 50%;
    margin-top: -5px;
    box-shadow: 0px 0px 2px rgba(40, 41, 61, 0.04), 0px 4px 8px rgba(96, 97, 112, 0.12);
  }

  .time {
    margin-top: 10px;
    width: 90%;
    display: flex;
    justify-content: space-between;
  }

  .play {
    height: 20px;
  }

  amityeko-tg-caption {
    color: rgba(235, 235, 245, 0.6);
  }

  amityeko-button {
    --amityeko-circle-button-size: 38px;
  }

  amityeko-tg-title {
    color: var(--private-title-color);
    text-align: center;
  }
`;
//# sourceMappingURL=styles.js.map